import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Paper,
  Typography,
  Stack,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
  ListItemButton,
} from '@mui/material';
import {
  Language as LanguageIcon,
  Security as SecurityIcon,
  People as PeopleIcon,
  Notifications as NotificationsIcon,
  Apps as AppsIcon,
} from '@mui/icons-material';

const Settings: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    // Check if user is admin
    const user = localStorage.getItem('user');
    if (user) {
      const userData = JSON.parse(user);
      setIsAdmin(userData.role?.type === 'admin' || userData.role?.type === 'authenticated');
    }
  }, []);

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        {t('navigation.settings')}
      </Typography>

      <Stack spacing={3} sx={{ mt: 3 }}>
        <Paper>
          <List>
            <ListItem>
              <ListItemIcon>
                <LanguageIcon />
              </ListItemIcon>
              <ListItemText
                primary="Language & Localization"
                secondary="Current language can be changed from the header (globe icon)"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <SecurityIcon />
              </ListItemIcon>
              <ListItemText
                primary="Security Settings"
                secondary="Manage roles and permissions in Strapi Admin panel"
              />
            </ListItem>
            <Divider />
            <ListItem>
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText
                primary="User Management"
                secondary="User accounts are managed in Strapi Admin"
              />
            </ListItem>
            <Divider />
            {isAdmin && (
              <>
                <ListItemButton onClick={() => navigate('/modules')}>
                  <ListItemIcon>
                    <AppsIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary="Module Management"
                    secondary="Activate/deactivate system modules and manage user access"
                  />
                </ListItemButton>
                <Divider />
              </>
            )}
            <ListItem>
              <ListItemIcon>
                <NotificationsIcon />
              </ListItemIcon>
              <ListItemText
                primary="Notifications"
                secondary="Email and push notifications (coming soon)"
              />
            </ListItem>
          </List>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            System Information
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2">
              <strong>Version:</strong> 1.0.0
            </Typography>
            <Typography variant="body2">
              <strong>Backend:</strong> Strapi v4.20
            </Typography>
            <Typography variant="body2">
              <strong>Frontend:</strong> React 18 + TypeScript
            </Typography>
            <Typography variant="body2">
              <strong>API URL:</strong> {process.env.REACT_APP_API_URL || 'https://darb.aiastra.io'}
            </Typography>
          </Stack>
        </Paper>

        <Paper sx={{ p: 3 }}>
          <Typography variant="h6" gutterBottom>
            Quick Links
          </Typography>
          <Stack spacing={1}>
            <Typography variant="body2">
              <strong>Strapi Admin:</strong>{' '}
              <a href="https://darb.aiastra.io/admin" target="_blank" rel="noopener noreferrer">
                https://darb.aiastra.io/admin
              </a>
            </Typography>
            <Typography variant="body2">
              <strong>API Documentation:</strong> Available in Strapi Admin
            </Typography>
            <Typography variant="body2">
              <strong>Support:</strong> Check documentation files in project root
            </Typography>
          </Stack>
        </Paper>
      </Stack>
    </Box>
  );
};

export default Settings;

